module.exports = __webpack_public_path__ + "static/media/Motorista-theme.8d0cbe00.svg";